module.exports = __webpack_public_path__ + "static/infographic-vector-5d06d26a8c821a43f0699bc1a06acb5a.png";